<template>
    <div class="site-row flow-step">
        <p class="flow-step__headline">{{step.Headline}}</p>
        <ul class="flow-step__items">
            <li v-for="item in step.Items">
                <flowStepItem :item="item" :stepId="step.Id" :allowSelectingMultipleItems="step.AllowSelectingMultipleItems" :dictionary="dictionary" v-bind="$attrs"></flowStepItem>
            </li>
        </ul>
        <nav class="flow-step__navigation">
        <button class="flow__button" type="button" v-if="currentStepIndex != 0" v-on:click="handleStepChangeBackward">{{dictionary.FlowStepPreviousButtonText}}</button>
        <button class="flow__button" type="button" v-on:click="handleStepChangeForward" v-if="nextStepId != 0">{{dictionary.FlowStepNextButtonText}}</button>
        </nav>
    </div>
</template>
<script>
    import FlowStepItem from "./flowStepItem.vue";
    export default {
        name: "flowStep",
        components: {
            FlowStepItem
        },
        props: ["step", "dictionary","currentStepIndex", "nextStepId"],
        methods: {
            handleStepChangeForward() {
                this.$emit('stepChangeForward');
            },
            handleStepChangeBackward() {
                this.$emit('stepChangeBackward');
            }
        }
    };
</script>
